<template>
    <div class="personalAuthorityManagement">
      <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "personalAuthorityManagement",
  data() {
    return {};
  }
};
</script>
<style lang="stylus" scoped>
    
</style>
